import AppLayout from "../components/layout/AppLayout";
import DriverTableComponent from "../components/driver/DriverTableComponent";

export default function Driver() {
  return (
    <AppLayout>
      <DriverTableComponent />
    </AppLayout>
  );
}
